import React, { useEffect, useRef, useState } from 'react'
import { json, useParams } from 'react-router-dom';
import ChampionProfile from '../components/ChampionProfile';
import axios from 'axios';

const Tracker = () => {
    let {user} = useParams();
    let pseudo = user?user:"Invocateur";
    const [UserData, setUserData] = useState([])
    const [ChampList, setChampList] = useState({})
    const [ChampArray, setChampArray] = useState([])
    const [Loaded, setLoaded] = useState(false)
    const [Search, setSearch] = useState("")


    useEffect(() => {        
        setLoaded(loadAllChamps())
    }, [ChampList])

    useEffect(() => {
        if(UserData.length !== 0){
            localStorage.setItem(pseudo, JSON.stringify(UserData));
        }
        
    }, [UserData])

    useEffect(() => {

        getChamps();

        if(localStorage.getItem(pseudo)){
            let data = JSON.parse(localStorage.getItem(pseudo))
            setUserData(data);
        }

        // getChallengeInfo();
    }, [pseudo])
    
    useEffect(() => {
        setLoaded(false)
        cleanChamps()
        setLoaded(searchChamps())
    }, [Search])

    const loadAllChamps = () => {
        let arr = []
        for (const [key, value] of Object.entries(ChampList)) {
            arr.push([key, value]);
        }
        setChampArray(arr)
        return true;
    }

    const searchChamps = () => {
        if(Search !== ""){
            setChampArray([])
            let arr = []
            for (const [key, value] of Object.entries(ChampList)) {
                if(key.toLowerCase().includes(Search.toLowerCase())){
                    arr.push([key, value]);
                }
                setChampArray(arr);
            }
        }else{
            loadAllChamps();
        }
        console.log(ChampArray);
        return true;
    }

    const getChamps = async () => {
        setChampList({})
        const resp = await axios.get("http://ddragon.leagueoflegends.com/cdn/13.18.1/data/en_US/champion.json")
        setChampList(resp.data.data)
    }

    const getChallengeInfo = async () => {
        const challengeId = 101301 
        const config = {
            headers : {
            "X-Riot-Token": "RGAPI-b1b7bbf6-f677-40b0-93ff-e197e9e08c71",
            }
        }
        const { resp } =  await axios.get(`https://euw1.api.riotgames.com/lol/challenges/v1/challenges/${challengeId}/config?api_key=RGAPI-b1b7bbf6-f677-40b0-93ff-e197e9e08c71`)  
        console.log(resp)
        return resp
    }

    const cleanChamps = async () => {
        await setChampArray([]);
    }
    
  return (
    <div className='main'>
        <h1>Bienvenue {pseudo}</h1>
        <input type='text' onChange={(e) => setSearch(e.target.value)}></input>
        <div>&nbsp;</div>
        <hr/>
        <div className='wrapper'>
            { Loaded &&
                ChampArray.map((champ) => 
                    <ChampionProfile name={champ[0]} nameWritten={champ[1].name} img={champ[1].image.sprite} validateEvent={(event) => {
                        UserData.find((element) => element === champ[0])
                        ? setUserData(UserData.filter((element) => element !== champ[0]))
                        : setUserData([...UserData, champ[0]])
                    }} active={UserData.find((element) => element === champ[0])}/>
                )
            }
        </div>
    </div>
  )
}

export default Tracker